import React from "react";
import beforeIcon from "../../images/arrow_back_ios-24px.svg";
import cn from "../../lib/classnames";
import styles from "./BackButton.module.css";

const strings = {
    backText: "Back To Application",
};

type Props = {
    onClick: () => void;
    className?: string;
    disabled?: boolean;
};

export default function BackButton({onClick, className, disabled = false}: Props) {
    return (
        <button
            className={cn(styles.button, className)}
            disabled={disabled}
            onClick={onClick}
            type="button"
        >
            <img src={beforeIcon} alt="" className={styles.image} />
            <span className={styles.text}>{strings.backText}</span>
        </button>
    );
}
